






































































































import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { computed } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  components: { SkeletonLoaderItem },
  props: [
    "items",
    "available",
    "title",
    "desc",
    "date",
    "icon",
    "is_loading",
    "max_items",
    "display_show_more_btn",
  ],
  setup(props) {
    const count_width = computed(() => {
      const max_count = Math.max(
        ...(props.items as Array<{ count: number }>).map((d) => d.count)
      );
      switch (true) {
        case max_count === 0:
        case max_count >= 0 && max_count < 10:
          return "1rem";
        case max_count >= 10 && max_count < 100:
          return "1.5rem";
        case max_count >= 100 && max_count < 1_000:
          return "2rem";
        case max_count >= 1_000 && max_count < 10_000:
          return "3rem";
        case max_count >= 10_000 && max_count < 100_000:
          return "3.2rem";
        case max_count >= 100_000 && max_count < 1_000_000:
          return "3.8rem";
        case max_count >= 1_000_000 && max_count < 10_000_000:
          return "4.3rem";
        default:
          return "2rem";
      }
    });
    const more_count = computed(() => {
      if (props.display_show_more_btn) {
        return (props.items as any[]).length - (props.max_items as number);
      } else {
        const total_with_count = (props.items as Array<{
          count: number;
        }>).reduce((acc, item) => {
          if (item.count > 0) {
            acc++;
          }
          return acc;
        }, 0);
        const more = total_with_count - (props.max_items as number);
        return more;
      }
    });
    return {
      more_count,
      count_width,
    };
  },
});
